var Deeplink = {
    oldHash: null,

    init: function() {
        var _this = this;

        // HASHCHANGE
        $(window).on('hashchange', function (e) {
            if (_this.oldHash != location.href.split("#")[1] && Parser.resultsReady) {
                _this.oldHash = location.href.split("#")[1];
                var params = [
                    {id:'year', val: _this.getFromHash('y') },
                    {id:'make', val: _this.getFromHash('mk') },
                    {id:'model', val: _this.getFromHash('mo') },
                    {id:'submodel', val: _this.getFromHash('ss') }
                ];

                for (var t = 0; t < params.length; t ++) {
                    if(params[t].val == null) {
                        break;
                    }
                    console.log("GETTING DD,", (params[t]));
                    DropDowns.getProducts(params[t].id, (params[t].val));
                    $('#'+params[t].id).val((params[t].val));
                }

                // fade in dd when done loading
                $('.dropdowns').removeClass('fade-out').addClass('fade-in');
                $('.loader').addClass('hide');
                DropDowns.displayContent(params);
            } else {
                // fade in dd
                $('.dropdowns').removeClass('fade-out').addClass('fade-in');
                $('.loader').addClass('hide');
            }
        });

        _this.triggerChange = $.proxy(_this,"triggerChange");
        if (Parser.resultsReady) {
            this.triggerChange();
        } else {
            $(Parser).on('resultsReady', this.triggerChange);
        }
    },

    getFromHash: function(key) {
        if(location.hash.match(new RegExp(key+'=([^&]*)'))){
            // location.href.split("#")[1] because Firefox automaticaly decodes URL when calling location.hash
            return (location.href.split("#")[1].match(new RegExp(key+'=([^&]*)'))[1]);
        } else {
            return null;
        }
    },

    triggerChange:function(){
        var self = this;
        $(Parser).off('resultsReady',self.triggerChange);
        if (!Parser.resultsReady) {
            return;
        }
        $(window).trigger('hashchange');
    }
};
